<form-control
  direction="grouping"
  [config]="countyConfig"
  [control]="formGroup.get(countyConfig.prop)"
>
</form-control>
